import { defaultDataIdFromObject, useMutation } from '@apollo/client';
import * as immutable from 'object-path-immutable';
import { get } from 'lodash';
import { useIntl, defineMessages } from 'react-intl';

import toast from 'helpers/toast';
import { SUBTASK_DELETE } from '../graphql/mutations.graphql';
import TASK_FRAGMENT from '../../gql/TaskFragment.graphql';

const messages = defineMessages({
  deleteError: {
    id: 'Projects.taskList.subTasks.deleteError',
    defaultMessage: 'An error occurred deleting this question.',
    description: 'Message when an error occurs deleting a subtask',
  },
});

const useDeleteSubtask = ({ close, taskId }) => {
  const { formatMessage } = useIntl();

  const showErrorToast = (errorMsg) => {
    toast.error(errorMsg);
  };

  const [deleteSubtask] = useMutation(SUBTASK_DELETE, {
    onCompleted: () => {
      close();
    },
    update: (
      cache,
      {
        data: {
          subTaskDelete: { deletedId, errors },
        },
      },
    ) => {
      if (!deletedId || errors.length) {
        showErrorToast(errors[0].message);
      }

      const cacheId = defaultDataIdFromObject({
        __typename: 'Task',
        id: taskId,
      });

      const cachedData = cache.readFragment({
        id: cacheId,
        fragment: TASK_FRAGMENT,
        fragmentName: 'TaskFragment',
      });

      const subtaskNodes = get(cachedData, 'subTasks.nodes', []);
      const updatedSubtaskNodes = subtaskNodes.filter(
        (subtask) => subtask.id !== deletedId,
      );

      const newQueryData = immutable.set(
        cachedData,
        'subTasks.nodes',
        updatedSubtaskNodes,
      );

      cache.writeFragment({
        id: cacheId,
        fragment: TASK_FRAGMENT,
        fragmentName: 'TaskFragment',
        data: newQueryData,
      });
    },
    onError: () => {
      showErrorToast(formatMessage(messages.deleteError));
    },
  });

  return {
    deleteSubtask,
  };
};

export default useDeleteSubtask;
